import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'

import '@/assets/css/reset.css'
import '@/assets/css/main.css'
import '@/assets/new_theme/style.css' // added new theme CSS
import i18n from './assets/i18n'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import routes from './router'
import revealDirective from './directives/reveal'


const app = createApp(App)
const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    // Fail-safe: only scroll if the element actually exists in the DOM
                    if (document.querySelector(to.hash)) {
                        resolve({ el: to.hash, behavior: 'smooth' });
                    } else {
                        resolve({ top: 0 });
                    }
                }, 400); // Increased time for production chunk loading
            });
        }
        return { top: 0 };
    }
})
app.directive('reveal', revealDirective)
app.use(i18n) // 注入 i18n
app.use(ElementPlus)
app.use(router)
app.mount('#app')
